export function calcularTotalCuotaSimulador(
    {vencimientoEnDias,
    Amount,
    admon}) {

    //Calcular interes
    const interest = Math.round(
        Amount * (0.0626666 / 100) * vencimientoEnDias
    );

    //Calcular IVA
    const iva = Math.round(admon * (19 / 100));
    console.log(Amount, interest, admon, iva);
    //Calcular Total
    const total = Math.round(Amount + interest + admon + iva);
    return total;
}